<div>
  <ng-container *ngIf="devMode">
    <ins class="adsbygoogle"
     style="display:inline-block;width:200px;height:600px"
     data-ad-client="ca-pub-4347523458652347"
     data-ad-slot="6151497267"
     addtest="on"></ins>
  </ng-container>
  <ng-container *ngIf="!devMode">
    <ins class="adsbygoogle"
     style="display:inline-block;width:200px;height:600px"
     data-ad-client="ca-pub-4347523458652347"
     data-ad-slot="6151497267"
     addtest="off"></ins>
  </ng-container>
</div>
